import { type APIResponse, type MatterUserConnection } from "@/lib/types";
import { authenticatedFastApiAxiosInstance } from "../../http";
import { baseFastApiMatterRoute } from "./matter";

type MatterUserConnectionCreateInput = {
  label: string;
  matterId: string;
  userId: string;
} & Partial<
  Pick<
    MatterUserConnection,
    | "fileId"
    | "litigationDateId"
    | "medicalTreatmentBalanceConfirmationId"
    | "signatureRequestComplete"
    | "signatureRequestId"
    | "signatureRequestPasscode"
    | "statuteOfLimitationsId"
    | "taskId"
    | "vehicleId"
  >
>;

type MatterUserConnectionUpdateInput = Pick<
  MatterUserConnection,
  "dateModified" | "id" | "matterId"
> &
  Partial<Omit<MatterUserConnectionCreateInput, "matterId">>;

export const createMatterUserConnectionV1 = (
  data: MatterUserConnectionCreateInput,
) =>
  authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterUserConnection>
    >(`${baseFastApiMatterRoute}/users-connections`, data)
    .then((res) => res.data);

export const deleteMatterUserConnectionV1 = (data: {
  id: string;
  matterId: string;
}) =>
  authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterUserConnection>
    >(`${baseFastApiMatterRoute}/users-connections/${data.id}`)
    .then((res) => res.data);

export const updateMatterUserConnectionsV1 = (data: {
  connections: MatterUserConnectionUpdateInput[];
}) =>
  authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterUserConnection>
    >(`${baseFastApiMatterRoute}/users-connections`, data)
    .then((res) => res.data);
